module.exports = {"id":"224151","name":"Henry Martín","rating":"71","photo":"./data/images/photos/3/224151.png","club":{"name":"América","logo":"./data/images/clubs/America.png"},"positions":["BU","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HenryMartin0.json
// module id = 1728
// module chunks = 0